var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5333 21.75C15.6551 21.75 14.9431 21.0381 14.9431 20.1599C14.9431 16.3336 12.2082 13.5701 9.05687 12.8618V20.1599C9.05687 21.0381 8.34494 21.75 7.46674 21.75H4.67704C3.33662 21.75 2.25 20.6634 2.25 19.323V4.67704C2.25 3.33662 3.33662 2.25 4.67704 2.25H19.323C20.6634 2.25 21.75 3.33662 21.75 4.67704V19.323C21.75 20.6634 20.6634 21.75 19.323 21.75H16.5333ZM7.46674 11.0933C7.99923 11.0933 8.53172 11.1434 9.05687 11.2405C13.0024 11.9704 16.5333 15.3589 16.5333 20.1599H19.323C19.7852 20.1599 20.1599 19.7852 20.1599 19.323V4.67704C20.1599 4.21483 19.7852 3.84013 19.323 3.84013H4.67704C4.21483 3.84013 3.84013 4.21483 3.84013 4.67704V19.323C3.84013 19.7852 4.21483 20.1599 4.67704 20.1599H7.46674V11.0933Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.68e225896609ec4686e52b877b54b2f4.svg";
export { ForwardRef as ReactComponent };